(function () {
  'use strict';

  /* ============================================================
     WALLPLATE WAREHOUSE
     FAMILY QUICK-ORDER + WHOLE HOME PLANNER INTEGRATION
     ============================================================ */

  var PLANNER_STORAGE_KEY = 'wpw_room_quantity_planner_v1';

  /*
   * These IDs match the configuration IDs used by the
   * Whole Home Wallplate Planner.
   */
  var PLANNER_CONFIGS = [
    {
      id: 'T',
      name: '1 Toggle',
      patterns: ['1 toggle']
    },
    {
      id: 'TT',
      name: '2 Toggle',
      patterns: ['2 toggle']
    },
    {
      id: 'TTT',
      name: '3 Toggle',
      patterns: ['3 toggle']
    },
    {
      id: 'TTTT',
      name: '4 Toggle',
      patterns: ['4 toggle']
    },
    {
      id: 'TTTTT',
      name: '5 Toggle',
      patterns: ['5 toggle']
    },

    {
      id: 'R',
      name: '1 Rocker / GFCI',
      patterns: ['1 rocker']
    },
    {
      id: 'RR',
      name: '2 Rocker / GFCI',
      patterns: ['2 rocker']
    },
    {
      id: 'RRR',
      name: '3 Rocker / GFCI',
      patterns: ['3 rocker']
    },
    {
      id: 'RRRR',
      name: '4 Rocker / GFCI',
      patterns: ['4 rocker']
    },
    {
      id: 'RRRRR',
      name: '5 Rocker / GFCI',
      patterns: ['5 rocker']
    },

    {
      id: 'D',
      name: '1 Duplex Outlet',
      patterns: ['1 duplex']
    },
    {
      id: 'DD',
      name: '2 Duplex Outlet',
      patterns: ['2 duplex']
    },

    {
      id: 'TR',
      name: '1 Toggle / 1 Rocker-GFCI',
      patterns: [
        '1 toggle / 1 rocker',
        '1 toggle/1 rocker'
      ]
    },
    {
      id: 'TD',
      name: '1 Toggle / 1 Duplex',
      patterns: [
        '1 toggle / 1 duplex',
        '1 toggle/1 duplex'
      ]
    },
    {
      id: 'RD',
      name: '1 Rocker-GFCI / 1 Duplex',
      patterns: [
        '1 rocker / 1 duplex',
        '1 rocker/1 duplex'
      ]
    },
    {
      id: 'TTR',
      name: '2 Toggle / 1 Rocker-GFCI',
      patterns: [
        '2 toggle / 1 rocker',
        '2 toggle/1 rocker'
      ]
    },
    {
      id: 'TTD',
      name: '2 Toggle / 1 Duplex',
      patterns: [
        '2 toggle / 1 duplex',
        '2 toggle/1 duplex'
      ]
    },

    {
      id: 'B',
      name: '1 Blank',
      patterns: ['1 blank']
    },
    {
      id: 'BB',
      name: '2 Blank',
      patterns: ['2 blank']
    }
  ];

  /* ============================================================
     EXISTING FAMILY QUANTITY FUNCTIONS
     ============================================================ */

  function quantityValue(value) {
    var cleaned = String(value == null ? '' : value).replace(/[^0-9]/g, '');
    var quantity = parseInt(cleaned, 10);

    return isNaN(quantity) || quantity < 0 ? 0 : quantity;
  }

  function maxQuantity(input, item) {
    var raw = input && input.getAttribute('data-max');

    if ((raw == null || raw === '') && item) {
      raw = item.getAttribute('data-max-quantity');
    }

    if (raw == null || raw === '') {
      return null;
    }

    var max = parseInt(raw, 10);

    return isNaN(max) ? null : Math.max(0, max);
  }

  function limitMessage(item, max) {
    var node = item ? item.querySelector('[data-stock-limit-message]') : null;

    if (!node) {
      return;
    }

    node.textContent = 'Only ' + max + ' in Stock';
    node.classList.add('is-visible');

    clearTimeout(node._wwTimer);

    node._wwTimer = setTimeout(function () {
      node.classList.remove('is-visible');
    }, 2600);
  }

  function clampInput(input, item, notify) {
    var value = quantityValue(input.value);
    var max = maxQuantity(input, item);

    if (max !== null && value > max) {
      value = max;

      if (notify) {
        limitMessage(item, max);
      }
    }

    input.value = value;

    return value;
  }

  function formatMoney(cents) {
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function'
    ) {
      return window.Shopify.formatMoney(cents);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  /* ============================================================
     PLANNER DATA
     ============================================================ */

  function loadPlannerState() {
    try {
      var raw = localStorage.getItem(PLANNER_STORAGE_KEY);

      if (!raw) {
        return null;
      }

      var state = JSON.parse(raw);

      if (
        !state ||
        !Array.isArray(state.rooms) ||
        !state.rooms.length
      ) {
        return null;
      }

      return state;
    } catch (error) {
      return null;
    }
  }

  function getPlannerRequirements() {
    var state = loadPlannerState();

    if (!state) {
      return null;
    }

    var totals = {};

    PLANNER_CONFIGS.forEach(function (config) {
      totals[config.id] = 0;
    });

    state.rooms.forEach(function (room) {
      if (!room || !room.quantities) {
        return;
      }

      PLANNER_CONFIGS.forEach(function (config) {
        totals[config.id] += quantityValue(
          room.quantities[config.id]
        );
      });
    });

    var required = [];

    PLANNER_CONFIGS.forEach(function (config) {
      var quantity = totals[config.id] || 0;

      if (quantity > 0) {
        required.push({
          id: config.id,
          name: config.name,
          quantity: quantity
        });
      }
    });

    if (!required.length) {
      return null;
    }

    var totalUnits = required.reduce(function (sum, item) {
      return sum + item.quantity;
    }, 0);

    return {
      state: state,
      totals: totals,
      required: required,
      totalUnits: totalUnits,
      configurationCount: required.length
    };
  }

  /* ============================================================
     PRODUCT TITLE → PLANNER CONFIGURATION
     ============================================================ */

  function normalizeTitle(title) {
    return String(title || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /*
   * We deliberately check combination configurations first.
   *
   * Example:
   * "1 Toggle / 1 Rocker" must match TR,
   * not the simpler "1 Toggle" configuration.
   */
  function configurationFromTitle(title) {
    var normalized = normalizeTitle(title);

    if (!normalized) {
      return null;
    }

    var orderedIds = [
      'TTR',
      'TTD',
      'TR',
      'TD',
      'RD',
      'TTTTT',
      'RRRRR',
      'TTTT',
      'RRRR',
      'TTT',
      'RRR',
      'TT',
      'RR',
      'DD',
      'BB',
      'T',
      'R',
      'D',
      'B'
    ];

    for (var i = 0; i < orderedIds.length; i++) {
      var id = orderedIds[i];

      var config = PLANNER_CONFIGS.find(function (candidate) {
        return candidate.id === id;
      });

      if (!config) {
        continue;
      }

      for (var p = 0; p < config.patterns.length; p++) {
        var pattern = config.patterns[p];

        /*
         * Titles generally contain:
         *
         * Fresno Satin Nickel - 1 Toggle Wallplate
         *
         * or similar.
         *
         * Matching the known configuration phrase lets us ignore
         * the collection/style prefix and "Wallplate" suffix.
         */
        if (normalized.indexOf(pattern) !== -1) {
          return config;
        }
      }
    }

    return null;
  }

  /* ============================================================
     FAMILY PRODUCT MAP
     ============================================================ */

  function buildFamilyConfigurationMap(root) {
    var map = {};

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-order-item]'),
      function (item) {
        var title = item.getAttribute('data-title') || '';
        var config = configurationFromTitle(title);

        /*
         * Accessories and products that don't correspond to one of
         * the planner's 19 configurations are ignored.
         */
        if (!config) {
          return;
        }

        var input = item.querySelector('[data-qty-input]');

        var max = input
          ? maxQuantity(input, item)
          : maxQuantity(null, item);

        var unavailable =
          item.classList.contains('is-unavailable') ||
          item.classList.contains('is-cart-depleted') ||
          !input ||
          input.disabled;

        map[config.id] = {
          config: config,
          element: item,
          input: input,
          max: max,
          unavailable: unavailable,
          title: title,
          variantId: parseInt(
            item.getAttribute('data-variant-id'),
            10
          ) || null
        };
      }
    );

    return map;
  }

  /* ============================================================
     PLANNER COMPATIBILITY
     ============================================================ */

  function analyzePlannerCompatibility(root, requirements) {
    var familyMap = buildFamilyConfigurationMap(root);

    var missing = [];
    var inventoryIssues = [];
    var available = [];

    requirements.required.forEach(function (requirement) {
      var familyItem = familyMap[requirement.id];

      /*
       * The product existing in the family is what determines
       * configuration compatibility.
       *
       * Current inventory is evaluated separately.
       */
      if (!familyItem) {
        missing.push(requirement);
        return;
      }

      available.push({
        requirement: requirement,
        familyItem: familyItem
      });

      var availableQuantity;

      if (familyItem.unavailable) {
        availableQuantity = 0;
      } else if (familyItem.max === null) {
        availableQuantity = null;
      } else {
        availableQuantity = familyItem.max;
      }

      if (
        availableQuantity !== null &&
        availableQuantity < requirement.quantity
      ) {
        inventoryIssues.push({
          id: requirement.id,
          name: requirement.name,
          needed: requirement.quantity,
          available: availableQuantity,
          familyItem: familyItem
        });
      }
    });

    return {
      familyMap: familyMap,
      missing: missing,
      inventoryIssues: inventoryIssues,
      available: available,
      completeMatch: missing.length === 0
    };
  }

  /* ============================================================
     PLANNER PANEL
     ============================================================ */

  function injectPlannerStyles() {
    if (document.getElementById('ww-family-planner-styles')) {
      return;
    }

    var style = document.createElement('style');

    style.id = 'ww-family-planner-styles';

    style.textContent = [
      '.ww-family-planner{',
      'margin:18px 0 24px;',
      'border:1px solid #cfe1f1;',
      'border-radius:10px;',
      'background:#f8fbfe;',
      'padding:18px;',
      '}',

      '.ww-family-planner__header{',
      'display:flex;',
      'align-items:flex-start;',
      'justify-content:space-between;',
      'gap:20px;',
      '}',

      '.ww-family-planner__eyebrow{',
      'font-size:12px;',
      'font-weight:800;',
      'letter-spacing:.04em;',
      'text-transform:uppercase;',
      'color:#1676d2;',
      'margin-bottom:4px;',
      '}',

      '.ww-family-planner__title{',
      'font-size:20px;',
      'font-weight:800;',
      'line-height:1.2;',
      'margin:0 0 5px;',
      '}',

      '.ww-family-planner__summary{',
      'font-size:14px;',
      'line-height:1.45;',
      'color:#56616b;',
      'margin:0;',
      '}',

      '.ww-family-planner__status{',
      'margin-top:14px;',
      'padding:11px 13px;',
      'border-radius:7px;',
      'font-size:14px;',
      'line-height:1.45;',
      '}',

      '.ww-family-planner__status--complete{',
      'background:#eef9f1;',
      'border:1px solid #cce7d3;',
      'color:#226e38;',
      '}',

      '.ww-family-planner__status--missing{',
      'background:#fff7ed;',
      'border:1px solid #f0d7b5;',
      'color:#8a5317;',
      '}',

      '.ww-family-planner__inventory{',
      'margin-top:10px;',
      'padding:11px 13px;',
      'border:1px solid #ead8a8;',
      'border-radius:7px;',
      'background:#fffaf0;',
      'color:#70571d;',
      'font-size:13px;',
      'line-height:1.45;',
      '}',

      '.ww-family-planner__list{',
      'margin:7px 0 0 18px;',
      'padding:0;',
      '}',

      '.ww-family-planner__list li{',
      'margin:3px 0;',
      '}',

      '.ww-family-planner__actions{',
      'display:flex;',
      'align-items:center;',
      'gap:9px;',
      'flex-wrap:wrap;',
      'margin-top:14px;',
      '}',

      '.ww-family-planner__apply{',
      'border:1px solid #1676d2;',
      'border-radius:7px;',
      'background:#1676d2;',
      'color:#fff;',
      'font:inherit;',
      'font-size:14px;',
      'font-weight:800;',
      'min-height:42px;',
      'padding:9px 16px;',
      'cursor:pointer;',
      '}',

      '.ww-family-planner__apply:hover{',
      'background:#0e5fae;',
      'border-color:#0e5fae;',
      '}',

      '.ww-family-planner__apply:disabled{',
      'opacity:.5;',
      'cursor:not-allowed;',
      '}',

      '.ww-family-planner__note{',
      'font-size:12px;',
      'color:#68737d;',
      'line-height:1.4;',
      '}',

      '.ww-family-planner__applied{',
      'display:none;',
      'margin-top:10px;',
      'font-size:13px;',
      'font-weight:700;',
      'color:#226e38;',
      '}',

      '.ww-family-planner__applied.is-visible{',
      'display:block;',
      '}',

      '@media(max-width:600px){',
      '.ww-family-planner{padding:14px;}',
      '.ww-family-planner__header{display:block;}',
      '.ww-family-planner__apply{width:100%;}',
      '}'
    ].join('');

    document.head.appendChild(style);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function plannerPanelHtml(requirements, analysis) {
    var html = '';

    html += '<div class="ww-family-planner__header">';

    html += '<div>';

    html +=
      '<div class="ww-family-planner__eyebrow">' +
      'Whole Home Planner' +
      '</div>';

    html +=
      '<h2 class="ww-family-planner__title">' +
      'Your Wallplate Project' +
      '</h2>';

    html +=
      '<p class="ww-family-planner__summary">' +
      'Your saved project requires <strong>' +
      requirements.totalUnits +
      ' wallplate' +
      (requirements.totalUnits === 1 ? '' : 's') +
      '</strong> in <strong>' +
      requirements.configurationCount +
      ' configuration' +
      (requirements.configurationCount === 1 ? '' : 's') +
      '</strong>.' +
      '</p>';

    html += '</div>';

    html += '</div>';

    if (analysis.completeMatch) {
      html +=
        '<div class="ww-family-planner__status ww-family-planner__status--complete">' +
        '<strong>✓ Complete Style Match</strong><br>' +
        'This wallplate family offers every configuration required for your project.' +
        '</div>';
    } else {
      html +=
        '<div class="ww-family-planner__status ww-family-planner__status--missing">' +
        '<strong>This style is missing ' +
        analysis.missing.length +
        ' required configuration' +
        (analysis.missing.length === 1 ? '' : 's') +
        '.</strong>';

      html += '<ul class="ww-family-planner__list">';

      analysis.missing.forEach(function (item) {
        html +=
          '<li>' +
          escapeHtml(item.name) +
          ' — Need ' +
          item.quantity +
          '</li>';
      });

      html += '</ul>';
      html += '</div>';
    }

    if (analysis.inventoryIssues.length) {
      html +=
        '<div class="ww-family-planner__inventory">' +
        '<strong>Inventory Notice</strong><br>' +
        'This style includes the configurations below, but current inventory cannot fill the complete quantity in your project.';

      html += '<ul class="ww-family-planner__list">';

      analysis.inventoryIssues.forEach(function (issue) {
        html +=
          '<li>' +
          escapeHtml(issue.name) +
          ' — Need ' +
          issue.needed +
          ', currently available to add: ' +
          issue.available +
          '</li>';
      });

      html += '</ul>';
      html += '</div>';
    }

    html += '<div class="ww-family-planner__actions">';

    if (analysis.available.length) {
      html +=
        '<button type="button" class="ww-family-planner__apply" data-ww-apply-planner>' +
        (
          analysis.completeMatch
            ? 'Apply My Planner Quantities'
            : 'Apply Available Configurations'
        ) +
        '</button>';

      html +=
        '<span class="ww-family-planner__note">' +
        'Quantities will be entered into the configuration list below. Review them before adding to your cart.' +
        '</span>';
    }

    html += '</div>';

    html +=
      '<div class="ww-family-planner__applied" data-ww-planner-applied>' +
      '✓ Planner quantities applied below.' +
      '</div>';

    return html;
  }

  function createPlannerPanel(root, requirements, analysis) {
    injectPlannerStyles();

    var existing = root.querySelector('[data-ww-family-planner]');

    if (existing) {
      existing.remove();
    }

    var panel = document.createElement('section');

    panel.className = 'ww-family-planner';
    panel.setAttribute('data-ww-family-planner', '');

    panel.innerHTML = plannerPanelHtml(
      requirements,
      analysis
    );

    /*
     * Insert the panel immediately before the product grid.
     * This keeps the planner message close to the configurations
     * it will populate.
     */
    var grid = root.querySelector('[data-family-items]');

    if (grid && grid.parentNode) {
      grid.parentNode.insertBefore(panel, grid);
    } else {
      root.insertBefore(panel, root.firstChild);
    }

    return panel;
  }

  /* ============================================================
     MAIN FAMILY INITIALIZATION
     ============================================================ */

  function initialize(root) {
    if (root.getAttribute('data-family-ready') === 'true') {
      return;
    }

    root.setAttribute('data-family-ready', 'true');

    var addButtons = Array.prototype.slice.call(
      root.querySelectorAll('[data-add-selected]')
    );

    var countNodes = Array.prototype.slice.call(
      root.querySelectorAll('[data-summary-count]')
    );

    var subtotalNodes = Array.prototype.slice.call(
      root.querySelectorAll('[data-summary-subtotal]')
    );

    var messageNodes = Array.prototype.slice.call(
      root.querySelectorAll('[data-order-message]')
    );

    function getItems() {
      return Array.prototype.slice.call(
        root.querySelectorAll('[data-order-item]')
      );
    }

    function selectedItems() {
      return getItems()
        .map(function (item) {
          var input = item.querySelector('[data-qty-input]');

          return {
            element: item,
            id: parseInt(
              item.getAttribute('data-variant-id'),
              10
            ),
            quantity: input
              ? clampInput(input, item, false)
              : 0,
            price:
              parseInt(
                item.getAttribute('data-price-cents'),
                10
              ) || 0
          };
        })
        .filter(function (item) {
          return item.quantity > 0 && item.id;
        });
    }

    function setMessages(text) {
      messageNodes.forEach(function (node) {
        node.textContent = text || '';
      });
    }

    function setButtonsLoading(isLoading, totalUnits) {
      var hasItems = totalUnits > 0;
      var label = 'Add to Cart';

      if (hasItems) {
        label =
          totalUnits === 1
            ? 'Add 1 Item to Cart'
            : 'Add ' + totalUnits + ' Items to Cart';
      }

      addButtons.forEach(function (button) {
        var inactive =
          isLoading || !hasItems;

        button.disabled = false;

        button.setAttribute(
          'aria-disabled',
          inactive ? 'true' : 'false'
        );

        button.classList.toggle(
          'is-disabled',
          !hasItems && !isLoading
        );

        button.classList.toggle(
          'is-loading',
          isLoading
        );

        button.textContent =
          isLoading
            ? 'Adding…'
            : label;
      });
    }

    function updateSummary() {
      var selected = selectedItems();
      var totalUnits = 0;
      var subtotal = 0;

      selected.forEach(function (item) {
        totalUnits += item.quantity;
        subtotal += item.price * item.quantity;
      });

      countNodes.forEach(function (node) {
        node.textContent =
          totalUnits === 1
            ? '1 Item'
            : totalUnits + ' Items';
      });

      subtotalNodes.forEach(function (node) {
        node.textContent = formatMoney(subtotal);
      });

      setButtonsLoading(false, totalUnits);
      setMessages('');

      getItems().forEach(function (item) {
        var input = item.querySelector('[data-qty-input]');

        var value = input
          ? quantityValue(input.value)
          : 0;

        var max = input
          ? maxQuantity(input, item)
          : null;

        var plus =
          item.querySelector('[data-qty-plus]');

        item.classList.toggle(
          'has-quantity',
          !!input && value > 0
        );

        if (plus && max !== null) {
          plus.classList.toggle(
            'is-at-limit',
            value >= max
          );

          plus.setAttribute(
            'aria-disabled',
            value >= max ? 'true' : 'false'
          );
        }
      });
    }

    /* ==========================================================
       APPLY WHOLE HOME PLANNER QUANTITIES
       ========================================================== */

    function applyPlannerQuantities(requirements, analysis, panel) {
      /*
       * Clear existing quantities first so the family page exactly
       * reflects the saved planner after Apply is clicked.
       */
      getItems().forEach(function (item) {
        var input = item.querySelector('[data-qty-input]');

        if (input && !input.disabled) {
          input.value = 0;
        }
      });

      analysis.available.forEach(function (match) {
        var requirement = match.requirement;
        var familyItem = match.familyItem;
        var input = familyItem.input;

        if (!input || input.disabled) {
          return;
        }

        var desired = requirement.quantity;
        var max = maxQuantity(input, familyItem.element);

        if (max !== null) {
          desired = Math.min(desired, max);
        }

        input.value = desired;
      });

      /*
       * Let the existing family page controller recalculate
       * item count, subtotal, card highlighting and button labels.
       */
      updateSummary();

      var appliedMessage = panel
        ? panel.querySelector('[data-ww-planner-applied]')
        : null;

      if (appliedMessage) {
        appliedMessage.classList.add('is-visible');
      }

      /*
       * Scroll to the first selected family product so the customer
       * can immediately review what was populated.
       */
      var firstSelected = null;

      getItems().some(function (item) {
        var input = item.querySelector('[data-qty-input]');

        if (
          input &&
          quantityValue(input.value) > 0
        ) {
          firstSelected = item;
          return true;
        }

        return false;
      });

      if (firstSelected) {
        window.setTimeout(function () {
          try {
            firstSelected.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          } catch (error) {
            firstSelected.scrollIntoView();
          }
        }, 150);
      }
    }

    /* ==========================================================
       EXISTING QUANTITY + CART CLICK HANDLER
       ========================================================== */

    root.addEventListener('click', function (event) {
      var plannerButton = event.target.closest
        ? event.target.closest('[data-ww-apply-planner]')
        : null;

      if (
        plannerButton &&
        root.contains(plannerButton)
      ) {
        event.preventDefault();

        var requirements =
          getPlannerRequirements();

        if (!requirements) {
          return;
        }

        var analysis =
          analyzePlannerCompatibility(
            root,
            requirements
          );

        var panel =
          plannerButton.closest(
            '[data-ww-family-planner]'
          );

        applyPlannerQuantities(
          requirements,
          analysis,
          panel
        );

        return;
      }

      var qtyButton = event.target.closest
        ? event.target.closest(
            '[data-qty-minus], [data-qty-plus]'
          )
        : null;

      if (
        qtyButton &&
        root.contains(qtyButton)
      ) {
        event.preventDefault();
        event.stopPropagation();

        var item =
          qtyButton.closest('[data-order-item]');

        var input = item
          ? item.querySelector('[data-qty-input]')
          : null;

        if (!input || input.disabled) {
          return;
        }

        var value =
          quantityValue(input.value);

        var max =
          maxQuantity(input, item);

        if (
          qtyButton.hasAttribute(
            'data-qty-plus'
          )
        ) {
          if (
            max !== null &&
            value >= max
          ) {
            input.value = max;
            limitMessage(item, max);
          } else {
            input.value = value + 1;
          }
        } else {
          input.value =
            Math.max(0, value - 1);
        }

        updateSummary();

        return;
      }

      var addButton = event.target.closest
        ? event.target.closest('[data-add-selected]')
        : null;

      if (
        !addButton ||
        !root.contains(addButton)
      ) {
        return;
      }

      event.preventDefault();

      var selected =
        selectedItems();

      if (
        !selected.length ||
        addButton.classList.contains('is-loading')
      ) {
        updateSummary();
        return;
      }

      var selectedTotal =
        selected.reduce(function (sum, item) {
          return sum + item.quantity;
        }, 0);

      setButtonsLoading(
        true,
        selectedTotal
      );

      setMessages('');

      fetch('/cart/add.js', {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        credentials: 'same-origin',

        body: JSON.stringify({
          items: selected.map(function (item) {
            return {
              id: item.id,
              quantity: item.quantity
            };
          })
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response
              .json()
              .then(function (error) {
                throw error;
              });
          }

          return response.json();
        })
        .then(function () {
          selected.forEach(function (selectedItem) {
            var item = selectedItem.element;
            var input = item.querySelector('[data-qty-input]');
            var oldMax = maxQuantity(input, item);

            if (oldMax !== null) {
              var newMax = Math.max(
                0,
                oldMax - selectedItem.quantity
              );

              if (input) {
                input.setAttribute('data-max', String(newMax));
              }

              item.setAttribute(
                'data-max-quantity',
                String(newMax)
              );
            }

            if (input) {
              input.value = 0;
            }
          });

          updateSummary();

          if (
            window.ajaxifyShopify &&
            typeof window.ajaxifyShopify.refreshCartAndOpen ===
              'function'
          ) {
            window.ajaxifyShopify.refreshCartAndOpen();
            return;
          }

          /* Fallback for a theme where Ajaxify did not initialize. */
          var toggle = document.querySelector('.cart-toggle');

          if (toggle) {
            toggle.click();
          } else {
            setMessages('Items were added to your cart.');
          }
        })
        .catch(function (error) {
          setButtonsLoading(
            false,
            selectedTotal
          );

          setMessages(
            (
              error &&
              (
                error.description ||
                error.message
              )
            ) ||
            'Some items could not be added. Please try again.'
          );
        });
    });

    /* ==========================================================
       EXISTING INPUT HANDLERS
       ========================================================== */

    root.addEventListener('input', function (event) {
      if (
        !event.target.matches ||
        !event.target.matches('[data-qty-input]')
      ) {
        return;
      }

      event.target.value =
        String(event.target.value)
          .replace(/[^0-9]/g, '');

      var item =
        event.target.closest('[data-order-item]');

      var max =
        maxQuantity(event.target, item);

      if (
        max !== null &&
        quantityValue(event.target.value) > max
      ) {
        event.target.value = max;
        limitMessage(item, max);
      }

      updateSummary();
    });

    root.addEventListener('change', function (event) {
      if (
        !event.target.matches ||
        !event.target.matches('[data-qty-input]')
      ) {
        return;
      }

      clampInput(
        event.target,
        event.target.closest('[data-order-item]'),
        true
      );

      updateSummary();
    });

    root.addEventListener(
      'blur',
      function (event) {
        if (
          !event.target.matches ||
          !event.target.matches('[data-qty-input]')
        ) {
          return;
        }

        clampInput(
          event.target,
          event.target.closest('[data-order-item]'),
          true
        );

        updateSummary();
      },
      true
    );

    /* ==========================================================
       INITIAL SUMMARY
       ========================================================== */

    updateSummary();

    /* ==========================================================
       INITIALIZE WHOLE HOME PLANNER
       ========================================================== */

    /*
var plannerRequirements =
  getPlannerRequirements();

if (plannerRequirements) {
  var plannerAnalysis =
    analyzePlannerCompatibility(
      root,
      plannerRequirements
    );

  createPlannerPanel(
    root,
    plannerRequirements,
    plannerAnalysis
  );
}
*/

  }

  /* ============================================================
     INITIALIZE
     ============================================================ */

  function initializeAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll(
        '[data-ww-family-order]'
      ),
      initialize
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );
  } else {
    initializeAll();
  }

}());
